import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Offertes from '@/components/offerte/Offertes'
import CreateOfferte from '@/components/offerte/CreateOfferte'
import Offerte from '@/components/offerte/Offerte'
import Login from '@/components/Login'
import AuthGuard from './auth-guard'
Vue.use(Router)
export default new Router({
    routes: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/offerte',
        name: 'Offertes',
        component: Offertes,
        beforeEnter : AuthGuard
      },
      {
        path: '/offerte/new',
        name: 'Maak Offerte',
        component: CreateOfferte,
        beforeEnter : AuthGuard
      },
      {
        path: '/offerte/new/:id',
        name: 'Bewerk Offerte',
        component: CreateOfferte,
        beforeEnter : AuthGuard
      },
      {
        path: '/offerte/:id',
        name: 'Offerte',
        props: true,
        component: Offerte,
        beforeEnter : AuthGuard
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      }
    ],
    mode:'history'
    })